/* globals console, module, require, window */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    templates = require('../utilities/handlebars').templates,
    // Table = require('./table'),
    Administrators = require('./administrators'),
    DashboardSidebarMenu = require('./dashboardSidebarMenu'),
    Organizations = require('./organizations'),
    Reports = require('./reports'),
    user = require('../models/user'),
    EOL = null;

module.exports = Marionette.View.extend({
    template: templates.dashboard,
    tagName: 'div',
    attributes: {
        class: 'dashboard row row-eq-height'
    },
    childViewEvents: {
        'select:organization': 'onSelectOrganization',
        'select:program':      'onSelectProgram'
    },
    childViews: {},
    regions: {
        administrators:       {el: 'div[name=administrators]',       replaceElement: true},
        organizations:        {el: 'div[name=organizations]',        replaceElement: true},
        reports:              {el: 'div[name=reports]',              replaceElement: true},
        dashboardSidebarMenu: {el: 'div[name=dashboardSidebarMenu]', replaceElement: true}
    },
    //
    close: function () {
        if (this.childViews.organizations) {
            this.childViews.organizations.close();
        }
    },
    initialize: function () {
        this.filteredPrograms = this.options.filteredPrograms;
        // this.templateContext = this.options;
        this.listenTo(user, 'change:roles', _.bind(function () {
            this.render();
        }, this));
    },
    onRender: function () {
        this.showChildView('dashboardSidebarMenu', new DashboardSidebarMenu());
        if (user.hasCapability('organization')) {
            this.childViews.organizations = this.showChildView('organizations', new Organizations([], {}));
            this.childViews.reports = this.showChildView('reports', new Reports({filteredPrograms: this.options.filteredPrograms}));
            if (user.hasCapability('administrator')) {
                this.childViews.administrators = this.showChildView('administrators', new Administrators());
            }
            this.showPanel(window.location.hash.substr(1));
        } else {
            _.each(this.childViews, function (childView, name) {
                childView.destroy();
            });
            this.childViews = {};
        }
        return this;
    },
    onSelectOrganization: function (options) {
        console.log('dashboard.onSelectOrganization - organization:%s', JSON.stringify(options));
        this.showPanel('organizations');
        this.childViews.organizations.onSelectOrganizationById(options.organizationId);
    },
    onSelectProgram: function (options) {
        console.log('dashboard.onSelectProgram - program:%s', JSON.stringify(options));
        this.showPanel('organizations');
        this.childViews.organizations.onSelectProgramById(options.organizationId, options.programId);
    },
    refreshReports: function () {
        this.childViews.reports.refresh();
    },
    showPanel: function (panel) {
        // console.log('dashboard.showPanel - panel:%s', panel);
        let hasCapability = false;
        panel = panel !== '*' ? panel : (this.priorPanel || 'organizations');
        _.each(this.childViews, function (childView, name) {
            childView.$el.toggleClass('hidden', name !== panel);
        });
        switch (panel) {
            case 'organizations':
            case 'reports':
                hasCapability = user.hasCapability('organization');
                break;
            case 'administrators':
                hasCapability = user.hasCapability('administrator');
                break;
        }
        if (hasCapability) {
            this.getChildView('dashboardSidebarMenu').selected(panel);
            this.priorPanel = panel;
        }
        if (panel === 'reports' && this.childViews.reports) {
            this.childViews.reports.reload();
        }
    }
});
